const CENTRAL_TIME_ZONE = "America/Chicago";
export const CHRONOLOGICLE_START_DATE = "2025-05-01";

export const getCentralDateKey = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: CENTRAL_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};

const dateKeyToUtcDay = (dateKey) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey);
  if (!match) throw new Error(`Invalid date key: ${dateKey}`);
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const calculateDayFromStart = (startDate, now = new Date()) => {
  const startDateKey = String(startDate).slice(0, 10);
  const diff = Math.floor(
    (dateKeyToUtcDay(getCentralDateKey(now)) - dateKeyToUtcDay(startDateKey)) / 86400000
  );
  return Math.max(1, diff + 1);
};
